import { get } from "react-hook-form";
import { getFormInstance } from "../repositories/FormsRepository";
import { useFormsContext } from "../context/formsContext";
import { getGroupedInstance } from "../helpers/getGroupedInstance";

export const useGetSelectedInstanceStatus = () => {
	const {
		state: { selectedInstanceId },
		actions: { setFormInstanceStatus },
	} = useFormsContext();

	return () => {
		if (
			selectedInstanceId === null ||
			selectedInstanceId === undefined ||
			!selectedInstanceId
		)
			return;
		getFormInstance(selectedInstanceId).then((res) => {
			if (res) {
				const instanceRows = get(res, "data", null);
				const instanceTable = instanceRows.tables[0];

				const { formInstance } = getGroupedInstance(instanceTable.rows);
				setFormInstanceStatus(formInstance[0]?.FormInstanceStatusCode);
			}
		});
	};
};
